import { render, staticRenderFns } from "./MultiActionButton.vue?vue&type=template&id=4e4b60d0&scoped=true"
import script from "./MultiActionButton.vue?vue&type=script&lang=js"
export * from "./MultiActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b60d0",
  null
  
)

export default component.exports